import { defineMessages } from 'react-intl';

type MessageKeys =
	| 'createAgentButton'
	| 'gotoStudioButton'
	| 'createButtonDisabledTooltip'
	| 'headerTitle'
	| 'headerSubtitle';

const message: Record<MessageKeys, { id: string; defaultMessage: string; description?: string }> =
	defineMessages({
		createAgentButton: {
			id: 'rovo-chat.browse-agents-fullscreen.create-agent-button-label',
			defaultMessage: 'Create agent',
			description: 'Button to create a new agent, shown in the header',
		},
		gotoStudioButton: {
			id: 'rovo-chat.browse-agents-fullscreen.goto-studio-button',
			defaultMessage: 'Go to Studio',
			description: 'Button that links to studio in the jeader',
		},
		createButtonDisabledTooltip: {
			id: 'rovo-chat.browse-agents-fullscreen.create-button-disabled-tooltip',
			defaultMessage: "You don't have permission to create agents in this site",
			description:
				'Tooltip to show when the create agent button is disabled due to user not having rovo agent create permissions on the site',
		},
		headerTitle: {
			id: 'rovo-chat.browse-agents-fullscreen-header.title',
			defaultMessage: 'Browse agents',
			description: 'Title of the fullscreen header to browse agents',
		},
		headerSubtitle: {
			id: 'rovo-chat.browse-agents-fullscreen-header.subtitle',
			defaultMessage: 'Discover agents that help move work forward.',
			description: 'Label that is shown under the header in browse agents fullscreen',
		},
	});

export default message;
